// App.js
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Home from "pages/Home";
import Header from "components/layout/Header";
import Banner from "components/layout/Banner";
import Footer from "components/layout/Footer";
import Layout from "components/layout/Layout";
import Page from "pages/Page";
import EventPage from "pages/EventPage";
import Blog from "pages/BlogPage";
import ContactPage from "pages/ContactPage";
import CookiesPage from "pages/CookiesPage";
import MentionsLegalesPage from "pages/MentionsLegalesPage";
import NotFoundPage from "pages/errors/NotFoundPage";
import DynamicSubSiteRoute from "components/routes/DynamicSubSiteRoute";
import ProfileSidebar from "components/settings/ProfileSidebar";
import AccessibilitySidebar from "components/settings/AccessibilitySidebar";
import Modal from "components/common/Modal";
import Sidebar from "components/navigation/Sidebar";
import ScrollToTop from "./components/routes/ScrollToTop";
import { AccessibilityProvider } from "contexts/AccessibilityContext";
import { ProfileProvider } from "contexts/ProfileContext";
import { ProfileSidebarProvider } from "./contexts/ProfileSidebarContext";
import { AccessibilitySidebarProvider } from "contexts/AccessibilitySidebarContext";
import { ModalProvider } from "contexts/ModalContext";
import { SubSiteProvider } from "contexts/SubSiteContext";
import { AuthProvider } from "contexts/AuthContext";
import PrivateRoute from "components/routes/PrivateRoute";

//Nouvelles pages
import ProgrammePage from "pages/ProgrammePage";
import SpectaclesPage from "pages/SpectaclesPage";
import ConcertsPage from "pages/ConcertsPage";
import SpectaclePage from "pages/SpectaclePage";
import LoginPage from "pages/LoginPage";
import MonComptePage from "pages/MonComptePage";

import useDocumentTitle from "hooks/useDocumentTitle";
import "./App.css";
import "styles/variables.css";
import "styles/main.css";
import "styles/access.css";
import "styles/fc.css";
import './fonts.js'; // Import de la déclaration de la font
import { Helmet } from 'react-helmet';
import api from "services/api";           // <-- On importe l'instance axios
import Spinner from "components/common/Spinner"; // Ou le Spinner que tu utilises déjà
import ComingSoonPage from "pages/ComingSoonPage";     // <-- Crée cette page si elle n'existe pas
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import redirectionRoutes from "components/routes/Redirections";
import MatomoScript from './MatomoScript';
import PanierPage from "pages/Panier";
import OrderFinalization from "pages/OrderFinalization";
import RegisterPage from "pages/RegisterPage";
import AccountConfirmation from "pages/AccountConfirmation";
import Page404 from "pages/Page404";
import Forbidden from "pages/Forbidden";
import CommandConfiramtion from "pages/CommandConfiramtion";
import ForgetPassword from "pages/ForgetPassword";
import ResetPassword from "pages/ResetPassword";
import UnauthRoute from "components/routes/UnauthRoute";
import { CartProvider } from "contexts/CartContext";
import AppContentWithAuth from "components/routes/AppContentWithAuth";
import Stream from "pages/Stream";

function App() {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }

  // ----- Début du rendu principal -----
  return (
    <div>
      {process.env.NODE_ENV === 'production' && <MatomoScript />}

      <AccessibilityProvider>
        <AccessibilitySidebarProvider>
          <ProfileSidebarProvider>
            <ProfileProvider>
              <ModalProvider>
                  <Router> {/* Un seul Router pour toute l'app */}
                    <AuthProvider>
                      <CartProvider>
                        <AppContentWithAuth />
                      </CartProvider>
                    </AuthProvider>
                  </Router>
              </ModalProvider>
            </ProfileProvider>
          </ProfileSidebarProvider>
        </AccessibilitySidebarProvider>
      </AccessibilityProvider>
    </div>
  );
}

export default App;
